export type Portfolio = {
  id: number
  title: string
  cover: string
  description: string
  url: string
  code: string
}
const portfolioData: Portfolio[] = [
  {
    id: 1,
    cover: '/portfolio/BeautyLounge/BeautyLounge.png',
    title: 'Beauty Lounge',
    description: 'React, TSX, SCSS, Axios',
    url: 'https://flourishing-tiramisu-dafd0d.netlify.app/',
    code: 'https://github.com/vvs0503624459/Beauty-Lounge.git',
  },
  {
    id: 2,
    cover: '/portfolio/FakeShop/FakeShop.png',
    title: 'FakeS hop',
    description: 'React, TSX, SCSS, Axios',
    url: 'https://jade-croissant-e6c9f1.netlify.app/',
    code: 'https://github.com/vvs0503624459/Educational-project-in-React.git',
  },
  {
    id: 3,
    cover: '/portfolio/ControlTask/ControlTask.png',
    title: 'Control Task',
    description: 'React, TSX',
    url: 'https://jovial-selkie-199a10.netlify.app/',
    code: 'https://github.com/vvs0503624459/Our-shop-page.git',
  },
]
export const getArticlesObject = (array: Portfolio[]) =>
  array.reduce(
    (object, portfolio) => ({
      ...object,
      [portfolio.id]: portfolio,
    }),
    {}
  )
export default portfolioData
